import { eEstadoDocumento } from "../common/enumModel";
import { IMaestroDocumentoUpdateModel } from "../interfaces/maestro-documento/IMaestroDocumentoUpdateModel";

export class MaestroDocumentoUpdateModel implements IMaestroDocumentoUpdateModel {
    idMaestroDocumento: number;
    documento: string;
    idEstado: eEstadoDocumento;

    constructor(){
        this.idMaestroDocumento = 0;
        this.documento = '';
        this.idEstado = eEstadoDocumento.ACTIVO;
    }
}